<template>
  <div class="fts-label-group" :class="{'label-group--information': information}">
    <fts-moji
      :emoji="getItem.emoji"
      :size="emojiSize"
      :class="getEmojiClass"
      v-if="getItem.emoji"
    />
    <font-awesome-icon
      :icon="getItem.icon"
      :style="getIconStyle"
      :class="[getIconClass, getItem.iconClass]"
      v-else-if="(fontawesome || document) && getItem.icon"
    />
    <i
      :style="getIconStyle"
      :class="[
        getItem.icon, 
        getIconClass, 
        {'label-group__icon--system': getItem.system}
      ]"
      v-else-if="getItem.icon"
    ></i>
    <div :style="getLabelStyle" :class="getLabelClass">
      <slot :item="getItem" :label="getItem.label" >{{getItem.label}}</slot>
    </div>
  </div>
</template>

<script>
import commons from '../commons/commons';
import FTSMoji from './FTSMoji';

export default {
  components: {
    "fts-moji": FTSMoji
  },
  props: {
    itemId: [String, Number],
    itemIdKey: {
      type: String,
      default: "id"
    },
    list: Array,
    item: Object,
    iconKey: {
      type: String,
      default: "icon"
    },
    iconColor: String,
    emoji: Boolean,
    emojiKey: {
      type: String,
      default: "emoji"
    },
    emojiSize: {
      type: Number,
      default: 16
    },
    fontawesome: Boolean,
    systemDefault: Boolean,
    systemDefaultKey: {
      type: String,
      default: "system"
    },
    labelKey: {
      type: String,
      default: "name"
    },
    labelColor: String,
    information: Boolean,
    informationModules: Array,
    document: Boolean,
    iconClass: String,
    appendIconClass: String,
    emojiClass: String,
    appendEmojiClass: String,
    labelClass: String,
    appendLabelClass: String,
  },
  computed: {
    getItem() {
      let item = null;
      let result = {};

      if (this.itemId && Array.isArray(this.list)) {
        item = this.list.find(x => x[this.itemIdKey] == this.itemId);
      } else if (Object.prototype.toString.call(this.item) === '[object Object]') {
        item = this.item;
      }

      if (item) {
        if (this.information) {
          if (this.emoji) {
            const findModule = Array.isArray(this.informationModules) && this.informationModules.find(x => x.id == item.connectionId);
            if (findModule && findModule.emoji) {
              result.emoji = findModule.emoji;
            }
          }

          if (!result.emoji) {
            result.icon = commons.informationIcon(item.type);
          }

          if (!result.icon && item.icon) {
            result.icon = item.icon;
          }

          result.system = item.system;
          result.label = item.displayName;
        } else if (this.document) {
          if (item.type === "PDF") {
            result.icon = ["far", "file-pdf"];
            result.iconClass= "fts-file-pdf";
          } else if (item.type === "Spreadsheet") {
            result.icon = ["far", "file-alt"];
            result.iconClass= "fts-file-excel";
          } else if (item.type === "HTML") {
            result.icon = ["far", "file-code"];
            result.iconClass= "fts-file-html";
          } else {
            result.icon = ["far", "file"];
            result.iconClass= "fts-file-default";
          }

          result.label = item.name;
        } else {
          if (this.emoji)
            result.emoji = item[this.emojiKey];
          else
            result.icon = item[this.iconKey];

          result.label = item[this.labelKey];
        }
      }

      if (!result.label) {
        result.label = "(undefined)";
      }

      return result;
    },
    getIconClass() {
      if (this.iconClass) {
        return this.iconClass;
      }

      let classes = ['label-group__icon'];

      if (this.appendIconClass) {
        classes.push(this.appendIconClass);
      }

      return classes.join(' ');
    },
    getIconStyle() {
      let styles = {};

      if (this.iconColor) {
        styles.color = this.iconColor;
      }

      return styles;
    },
    getEmojiClass() {
      if (this.emojiClass) {
        return this.emojiClass;
      }

      let classes = ['label-group__emoji'];

      if (this.appendEmojiClass) {
        classes.push(this.appendEmojiClass);
      }

      return classes.join(' ');
    },
    getLabelClass() {
      if (this.labelClass) {
        return this.labelClass;
      }

      let classes = ['label-group__label'];

      if (this.appendLabelClass) {
        classes.push(this.appendLabelClass);
      }

      return classes.join(' ');
    },
    getLabelStyle() {
      let styles = {};

      if (this.labelColor) {
        styles.color = this.labelColor;
      }

      return styles;
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";
.fts-label-group {
  min-width: 0;
  display: flex;
  align-items: center;
  &.label-group--information {
    [class^="fts-icon-"], [class*=" fts-icon-"] {
      line-height: inherit;
    }
    .label-group__icon {
      color: var(--fts-text);
    }
  }
}
.label-group__emoji {
  margin-right: 0.375rem;
}
.label-group__icon {
  margin-right: 0.375rem;
  color: var(--fts-default);
}
.label-group__label {
  @include text-overflow-ellipsis;
  color: var(--fts-text);
}
</style>